import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'

import { ConfigsSection, PrimarySection, TranslationSection } from './Section/'

const TrafficAlert = props =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}><FormHeader goBackPath={'/traffic-alert'} labelKey={'traffic_alert'} /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[3]} activeStep={0} orientation="vertical">
          <Step><PrimarySection /></Step>
          <Step><TranslationSection /></Step>
          <Step><ConfigsSection /></Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(TrafficAlert)
